import $i from "~/i18n";
import router from "~/routes.js";
export const login = async ({ commit, dispatch }, payload) => {
  try {
    let { data } = await axios.post(`/auth/login`, {
      username: payload.username,
      password: payload.password
    });
    if (data.state !== 200) {
      return data;
    }
    let token = data.token;
    window.axios.defaults.headers.common["Authorization"] = token;
    commit("SET_DATA", { id: "user", data: data });
    //commit("profile/SET_DATA_CHILD", { id: "bio", data: data.fullname , child:'fullname' },{root:true});

    localStorage.setItem("user", JSON.stringify(data));
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*365);
    document.cookie = "madyaId" + "=" + data.token + ";domain=madya.ir;path=/;expires=" + d.toGMTString();
    commit(
      "notifications/success",
      { message: $i.t("msg.welcome"), title: "" },
      { root: true }
    );
    dispatch("toggleIsLogin", true);
    dispatch("showModalLogin", false);
    if (localStorage && localStorage.singleShoppingCard) {
      dispatch(
        "basket/postPrebill",
        JSON.parse(localStorage.singleShoppingCard),
        { root: true }
      );
    }
    return data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const upsertUser = ({ commit }, payload) => {
  let user = { ...JSON.parse(localStorage.getItem("user")) };
  let newUser = {
    token: user.token,
    fullname: payload.fullname || user.fullname,
    img: payload.img || user.img,
    username: user.username
  };
  commit("SET_DATA", { id: "user", data: newUser });
  localStorage.setItem("user", JSON.stringify(newUser));
};
export const showModalLogin = ({ commit }, payload) => {
  commit("SET_DATA", { id: "showLogin", data: payload });
};
export const toggleIsLogin = ({ commit }, payload) => {
  // commit("setIsLogin", payload);
  commit("SET_DATA", { id: "isLogin", data: payload });
};
export const checkLogin = async ({ commit, dispatch }, payload) => {
  try {
    let { data } = await axios.post(`/auth/check`);
    if (data.state === 200) {
      commit("SET_DATA", { id: "isLogin", data: true });
      dispatch("showModalLogin", false);
    }
    if (data.state !== 200) {
      // dispatch("showModalLogin", true);
      commit("SET_DATA", { id: "isLogin", data: false });
      dispatch("logOut");
    }
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const register = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post("/users/register", {
      username: payload.username,
      fullname: payload.fullname,
      password: payload.password,
      re_password: payload.re_password,
      email: payload.email
    });
    if (data.state !== 200) {
      if (data.message === "Unique") {
        commit(
          "notifications/error",
          { message: "ایمیل تکراری است", title: "نام کاربری" },
          { root: true }
        );
      }
      return data;
    }
    // commit(
    //   "notifications/success",
    //   { message: "لینک فعال سازی ارسال شد", title: "تایید ایمیل" },
    //   { root: true }
    // );
    return data;
    // commit("setModalLogin", false);
    // commit(
    //   "notifications/info",
    //   {
    //     message: "برای ثبت مرحله نهایی ایمیل خود را تایید کنید",
    //     title: "تکمیل ثبت نام"
    //   },
    //   { root: true }
    // );
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const userActive = async ({},payload) => {
  try {
    let data = await axios.post("/users/active", {
      active_code: payload // active ID
    });
    return data;
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const submitPassword = async ({},payload) => {
  try {
    let body = { ...payload };
    let data = await axios.post("/users/set-new-pass-by-forget-code", {
      code: body.code,
      email: body.email,
      new_password: body.password,
      re_new_password: body.re_password
    });
    return data;
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const forget = async ({}, { email }) => {
  try {
    let data = await axios.post("/users/send-forget-code", {
      email: email
    });
    return data;
  } catch (e) {
    console.log(e);
    return e;
  }
};
export const logOut = async ({ commit }) => {
  try {
    let data = await axios.post("/auth/logout");
    sessionStorage.clear();
    localStorage.clear();
    commit('video/toggleModal', false, { root: true })
    var pastMonth = new Date()
    var after30days = pastMonth.setDate(pastMonth.getDate() - 30)
    pastMonth =  new Date(after30days)
    delete window.axios.defaults.headers.common['x-access-token']
    document.cookie ="madyaId= empty ; expires= " + pastMonth +"; path=/;domain=madya.ir;"


    commit("SET_DATA", { id: "user", data: null });
    commit("SET_DATA", { id: "isLogin", data: false });
    delete window.axios.defaults.headers.common["Authorization"];
    router.push("/");
    return data;
  } catch (e) {
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js